import {useState} from 'react';
import FindPasswordForm from './components/FindPasswordForm';
import ShowUserId from './components/ShowUserId';
import FindIdUserForm from "./components/FindIdUserForm";

const FindId = () => {
    const [isShowUserId, setIsShowUserId] = useState<boolean>(false);
    const [userId, setUserId] = useState<string[]>();

    return (
        <>
            <div className="flex flex-col max-w-md mx-auto px-4 mt-18">
        <span className="text-gray-900 text-24 font-normal text-center">
          {'아이디 찾기'}
        </span>
                {userId ? (
                    <ShowUserId userId={userId}/>
                ) : (
                    <FindIdUserForm setIsShowUserId={(ids) => setUserId(ids)}/>
                )}
            </div>
        </>
    );
};

export default FindId;
